<template>
	<div >

		<!--  -->
		<div class="follow_box1" style="margin-bottom: 40px;">
			<!-- <div class="follow_tit1">
				{{detailsInfo.time1 || ''}}
			</div> -->

			<div class="follow_box2">
				<!-- <div class="follow_tit2 ">

					<img :src="urlhead + '/pctime.png'" mode="aspectFit"></img>
					<span>
						{{detailsInfo.time1 || ''}} {{detailsInfo.time2 || ''}}
					</span>
				</div> -->
				<div class="follow_item">

					<div class="ri_content">

						<!-- <div class="timetil">
							<span>
								{{detailsInfo.time3 || ''}}
							</span>
						</div> -->
						<div class="contets" v-html="detailsInfo.content">
							<!-- {{detailsInfo.content || ''}} -->
						</div>

					</div>
					<div class="content_bom">
						<div class="txt">
							<!-- 由
							<template>
								{{detailsInfo.member_name || ''}}
							</template>
							跟进
							<template v-if="detailsInfo.assistant_member_id">
								<span v-for="(val, ind) in detailsInfo.assistant_member_name">{{val || ''}}
									<template v-if="ind != detailsInfo.assistant_member_name.length - 1">
										、
									</template>
								</span>协同
							</template> -->
						</div>
						<div class="czuo">
							<span @click="fn_edit_gen(1)">
								<i style="color:rgba(42, 117, 234, 1)" class="el-icon-edit-outline"></i>
							</span>
							<span @click="fn_edit_gen(2)">
								<i style="color:rgba(229, 80, 57, 1)" class="el-icon-delete"></i>
							</span>

						</div>
					</div>


				</div>
			</div>
		</div>
		
		<!-- 编辑跟进 -->
		<Dialog :show.sync="edit_show" :appendtobody="true" :name_width="genj_dialog">
			<span slot="body">
		
				<el-input type="textarea" :rows="5" resize="none" placeholder="请输入内容" class="input_w560"
				maxlength="500"
					v-model="edit_genj_obj.content">
				</el-input>
		
			</span>
		
			<div class="dialog-footer" slot="footer">
				<el-button type="primary" @click="genj_save">确 认</el-button>
				<el-button @click="edit_show = false">取 消</el-button>
			</div>
		</Dialog>
		<!--  -->
	
	
		<followuplink :show.sync="glshow"
		:correlation="correlation">
		</followuplink>
		
	</div>
</template>

<script>
	import followuplink from "./followuplink.vue";
	import Dialog from "components/content/dialog/Dialog";
	
	import {
		fn_retjson,
		retJSONArr,
	} from "network/defaults";
	import {
	  delCustomerFollowRecord,
	  edit_follow_record,
	} from "network/hk_customer";
	export default {
		
		props: {
			detaill: {
				type: Object | String,
				default: ()=>{
					return {}
				},
			},
			show: {
				type: Boolean,
				default: false,
			},
		},
		components: {
			followuplink,
			Dialog,
		},
		watch: {
			show(newVal) {
				this.glshow = false
				if(newVal) {
					this.setDates()
				}
				
			},
		},
		
		methods: {
			
			setDates(){
				let res = fn_retjson(this.detaill)
				let s1 = res.follow_time.split(" ");
				let s2 = s1[0].split("-"); // 2022 07 30
				let s3 = s1[1].slice(0, 5); // 11:50
				res.time1 = `${s2[0]}年${s2[1]}月`;
				res.time2 = `${s2[1]}月${s2[2]}日`;
				res.time3 = s3;
				this.detailsInfo = fn_retjson(res)
				this.glshow = true
				
				this.correlation = {
					project_id: res.project_id ? res.project_id : '',
					chance_id: res.chance_id ? res.chance_id : '',
					contract_id: res.contract_id ? res.contract_id : '',
					// return_id: res.return_id ? res.return_id : '',
				}
			},
			//
			fn_edit_gen(flag) {
				let obj = this.detailsInfo
				if (flag == 1) { // 编辑跟进
					// if (!retujudpower(this.is_powerEdit)) return
					console.log(this.detailsInfo,'this.detailsInfo')
					this.edit_show = true
					this.edit_genj_obj = fn_retjson(obj)
					this.dailyRecord = fn_retjson(obj)
				} else { // 删除跟进
					this.fn_delFollow(obj.id)
				}
				
			},
			// 修改 跟进记录
			genj_save() {
				let obj = this.edit_genj_obj
				let fd = new FormData()
				fd.append('id', obj.id)
				fd.append('content', obj.content)
				let oldDaily = this.dailyRecord
				if (oldDaily.content != obj.content) {
					let edit_data = [{
						field: '跟进内容', // 字段名称
						before: oldDaily.content, //修改前
						after: obj.content, //修改后
					}]
					fd.append('edit_data', JSON.stringify(edit_data))
				}
				edit_follow_record(fd).then(res => {
					if (!this.$handlereq(res))return
					this.$alertMess('修改成功')
					this.edit_show = false
					this.fn_Refresh()
				})
			},

			// 删除 跟进记录
			fn_delFollow(id) {
				// if (!retujudpower(this.is_powerDel)) return
				this.$confirm('您确定要删除吗?')
					.then(() => {
						delCustomerFollowRecord(id).then(res => {
							if (this.$handlereq(res)) {
								this.$alertMess('删除成功')
								this.fn_Refresh()
							}
						})
					}).catch(() => {});
			},
			fn_Refresh(){
				this.$emit('refresh')
			},
			
		},
		data() {
			return {
				correlation: '',
				
				urlhead: "https://scrm.51kuaiding.com/scrm/hktxcx/customer",
				
				detailsInfo: '',
				
				genj_dialog: {
				  name: "编辑跟进",
				  width: "400px",
				},
				edit_show: false,
				edit_genj_obj: '',
				dailyRecord: '',
				
				glshow: false,
			}
		},
	}
</script>

<style lang="scss" scoped>
@import "@/assets/css/public.scss";
.follow_item::before, .follow_item::after, .ri_content::before{
	content: none !important;
}
.follow_item{
	padding: 25px 0 0 0 !important;
}
</style>